import React, { useState } from "react";
import { saveAs } from "file-saver";
import { Document, Packer, Paragraph } from "docx";

const WordEditor = () => {
  const [paragraphs, setParagraphs] = useState([]); // Stores all paragraphs
  const [inputText, setInputText] = useState(""); // Stores current input text
  const [editingIndex, setEditingIndex] = useState(null); // Stores index of paragraph being edited
  const [editText, setEditText] = useState(""); // Stores text of paragraph being edited

  // Handle textarea input change
  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  // Add new paragraph to the list
  const handleAddParagraph = () => {
    if (inputText.trim() !== "") {
      setParagraphs([...paragraphs, inputText]);
      setInputText(""); // Clear textarea after adding
    }
  };

  // Delete a specific paragraph
  const handleDeleteParagraph = (index) => {
    const newParagraphs = paragraphs.filter((_, i) => i !== index);
    setParagraphs(newParagraphs);
  };

  // Move a paragraph up
  const handleMoveUp = (index) => {
    if (index > 0) {
      const newParagraphs = [...paragraphs];
      [newParagraphs[index], newParagraphs[index - 1]] = [
        newParagraphs[index - 1],
        newParagraphs[index],
      ];
      setParagraphs(newParagraphs);
    }
  };

  // Move a paragraph down
  const handleMoveDown = (index) => {
    if (index < paragraphs.length - 1) {
      const newParagraphs = [...paragraphs];
      [newParagraphs[index], newParagraphs[index + 1]] = [
        newParagraphs[index + 1],
        newParagraphs[index],
      ];
      setParagraphs(newParagraphs);
    }
  };

  // Select paragraph to edit
  const handleEditParagraph = (index) => {
    setEditingIndex(index);
    setEditText(paragraphs[index]);
  };

  // Save the edited paragraph
  const handleSaveEdit = () => {
    const updatedParagraphs = [...paragraphs];
    updatedParagraphs[editingIndex] = editText;
    setParagraphs(updatedParagraphs);
    setEditingIndex(null);
    setEditText("");
  };

  // Generate DOCX file
  const generateDocx = () => {
    const doc = new Document({
      sections: [
        {
          children: paragraphs.map(
            (para) => new Paragraph({ text: para, spacing: { after: 200 } })
          ),
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "custom_document.docx");
    });
  };

  return (
    <div
      style={{
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
      }}
    >
      <h2>Create Word Document</h2>

      {/* Textarea Input */}
      <textarea
        value={inputText}
        onChange={handleInputChange}
        placeholder="Write a new paragraph..."
        rows="4"
        style={{
          width: "80%",
          padding: "10px",
          fontSize: "16px",
          borderRadius: "5px",
          border: "1px solid #ccc",
          resize: "none",
        }}
      ></textarea>

      <br />

      {/* Add Paragraph Button */}
      <button
        onClick={handleAddParagraph}
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "green",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Add Paragraph
      </button>

      {/* Display Added Paragraphs */}
      <div
        style={{
          marginTop: "20px",
          textAlign: "left",
          width: "80%",
          margin: "auto",
        }}
      >
        {paragraphs.length > 0 && <h3>Added Paragraphs:</h3>}
        {paragraphs.map((para, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "10px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
          >
            {editingIndex === index ? (
              <input
                type="text"
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
                style={{
                  flex: 1,
                  padding: "5px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            ) : (
              <span
                onClick={() => handleEditParagraph(index)}
                style={{ flex: 1 }}
              >
                {para}
              </span>
            )}

            {editingIndex === index ? (
              <button
                onClick={handleSaveEdit}
                style={{
                  marginLeft: "10px",
                  padding: "5px",
                  backgroundColor: "orange",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                Save
              </button>
            ) : (
              <>
                <button
                  onClick={() => handleMoveUp(index)}
                  style={{
                    marginLeft: "10px",
                    padding: "5px",
                    backgroundColor: "blue",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  ↑
                </button>
                <button
                  onClick={() => handleMoveDown(index)}
                  style={{
                    marginLeft: "5px",
                    padding: "5px",
                    backgroundColor: "blue",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  ↓
                </button>
                <button
                  onClick={() => handleDeleteParagraph(index)}
                  style={{
                    marginLeft: "5px",
                    padding: "5px",
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  ❌
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      {/* Download Button */}
      {paragraphs.length > 0 && (
        <button
          onClick={generateDocx}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            fontSize: "18px",
            backgroundColor: "blue",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download DOCX
        </button>
      )}
    </div>
  );
};

export default WordEditor;
